const Locales = {
    'bg': 'Български',
    'en': 'English',
};

export default Locales;
